import { Chip } from "$components/chip";
import { FormattedMessage } from "react-intl";
import { AncEncounterStatus } from "../../../../__generated__/base.gql";

type BadgeConfig = {
  color: "warning" | "disabled";
  label: JSX.Element;
};

const BADGE_BY_STATUS: Partial<Record<AncEncounterStatus, BadgeConfig>> = {
  [AncEncounterStatus.InProgress]: {
    color: "warning",
    label: (
      <FormattedMessage
        id="ancRegister.status.inProgress"
        defaultMessage="In progress"
      />
    ),
  },
  [AncEncounterStatus.Cancelled]: {
    color: "disabled",
    label: (
      <FormattedMessage
        id="ancRegister.status.cancelled"
        defaultMessage="Cancelled"
      />
    ),
  },
  [AncEncounterStatus.OnHold]: {
    color: "disabled",
    label: (
      <FormattedMessage
        id="ancRegister.status.onHold"
        defaultMessage="On hold"
      />
    ),
  },
  [AncEncounterStatus.Planned]: {
    color: "disabled",
    label: (
      <FormattedMessage
        id="ancRegister.status.planned"
        defaultMessage="Planned"
      />
    ),
  },
  [AncEncounterStatus.Discontinued]: {
    color: "disabled",
    label: (
      <FormattedMessage
        id="ancRegister.status.discontinued"
        defaultMessage="Discontinued"
      />
    ),
  },
  [AncEncounterStatus.EnteredInError]: {
    color: "disabled",
    label: (
      <FormattedMessage
        id="ancRegister.status.enteredInError"
        defaultMessage="Entered in error"
      />
    ),
  },
  [AncEncounterStatus.Unknown]: {
    color: "disabled",
    label: (
      <FormattedMessage
        id="ancRegister.status.unknown"
        defaultMessage="Unknown"
      />
    ),
  },
};

export const AncStatusBadge = ({ status }: { status: AncEncounterStatus }) => {
  const config = BADGE_BY_STATUS[status];
  if (!config) {
    return null;
  }

  return <Chip color={config.color} size="small" label={config.label} />;
};
